// src/services/webrtc.js
class WebRTC {
  constructor() {
    this.peerConnection = null;
    this.dataChannel = null;
    this.stream = null;
  }

  async connect(signalingUrl, gameConfig) {
    this.peerConnection = new RTCPeerConnection({
      iceServers: [
        { urls: 'stun:stun.l.google.com:19302' }
      ]
    });

    this.dataChannel = this.peerConnection.createDataChannel('game', {
      ordered: false,
      maxRetransmits: 0
    });

    this.dataChannel.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === 'gameState') {
        this.onGameStateUpdate?.(data.state);
      }
    };

    this.peerConnection.ontrack = (event) => {
      this.stream = event.streams[0];
      this.onStreamUpdate?.(this.stream);
    };

    try {
      const offer = await this.peerConnection.createOffer();
      await this.peerConnection.setLocalDescription(offer);
      
      const response = await fetch(signalingUrl, {
        method: 'POST',
        body: JSON.stringify({
          offer,
          gameConfig
        })
      });
      
      const { answer } = await response.json();
      await this.peerConnection.setRemoteDescription(answer);
    } catch (error) {
      throw new Error('Failed to establish connection');
    }
  }

  sendInput(inputData) {
    if (this.dataChannel?.readyState === 'open') {
      this.dataChannel.send(JSON.stringify(inputData));
    }
  }

  disconnect() {
    this.dataChannel?.close();
    this.peerConnection?.close();
    this.stream = null;
  }
}

export default WebRTC;